import { MinusCircle } from '@phosphor-icons/react';
import { BaseButton } from './Button';
import styled from '@emotion/styled';

type SubtractButtonProps = {
  disabled?: boolean;
  onClick: () => void;
};

/**
 * Subtract Button component, part of Delogue design system.
 * @param onClick - on click handler
 * @param disabled - if true, the button will be disabled
 */
export const SubtractButton = ({ disabled = false, onClick }: SubtractButtonProps) => {
  return (
    <Button disabled={disabled} onClick={onClick}>
      <MinusCircle size={24} weight="fill" />
    </Button>
  );
};

const Button = styled(BaseButton)<{ disabled?: boolean }>`
  color: ${({ disabled, theme }) =>
    disabled ? theme.palette.bg.disabledSubtle : theme.palette.fg.secondary};
`;
